import { render, staticRenderFns } from "./JobAusbildungSummarySection.vue?vue&type=template&id=f5ab1276&scoped=true&"
import script from "./JobAusbildungSummarySection.vue?vue&type=script&lang=js&"
export * from "./JobAusbildungSummarySection.vue?vue&type=script&lang=js&"
import style0 from "./JobAusbildungSummarySection.vue?vue&type=style&index=0&id=f5ab1276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ab1276",
  null
  
)

export default component.exports